// import moment from "moment";

// const dateOfRelease = '2025-10-16';
// const integrationIds = ['bf405ede-50f9-4b9f-838e-054c12379036'];

// export const isCtripFormulaApplied = (createdAt, integrationId) => {
//   const releaseDate = moment(dateOfRelease, 'DD-MM-YYYY');
//   const bookingDate = moment(createdAt);

//   const isAfterRelease = bookingDate.isBefore(releaseDate, 'day');
//   const isValidIntegration = integrationIds.includes(integrationId);

//   return isAfterRelease && isValidIntegration;
// };


import moment from "moment";

const dateOfRelease = '2025-10-16';
const integrationIds = ['bf405ede-50f9-4b9f-838e-054c12379036'];

export const isCtripFormulaApplied = (createdAt, integrationId) => {
  // Parse using correct format (YYYY-MM-DD)
  const releaseDate = moment(dateOfRelease, 'YYYY-MM-DD');
  const bookingDate = moment(createdAt);

  // Check if booking date is before the release date
  const isBeforeRelease = bookingDate.isBefore(releaseDate, 'day');

  // Check if integration ID is one of the target ones
  const isValidIntegration = integrationIds.includes(integrationId);

  return isBeforeRelease && isValidIntegration;
};
